import GlyphIcon from "./GlyphIcon.mjs";

const ImActiveIcon = class extends GlyphIcon {
	render() {
		return(
			<GlyphIcon
				d="M26,14a7.95942,7.95942,0,0,0,2-.26331V19.5A3.50424,3.50424,0,0,1,24.5,23H17.12109l-4.85351,4.85352a2.09429,2.09429,0,0,1-1.46973.66552,1.733,1.733,0,0,1-.665-.1333A1.93406,1.93406,0,0,1,9,26.5V23H7.5A3.50424,3.50424,0,0,1,4,19.5V8.5A3.50424,3.50424,0,0,1,7.5,5H18.06946A8.00855,8.00855,0,0,0,18,6a7.95942,7.95942,0,0,0,.26331,2H7.5a.50641.50641,0,0,0-.5.5v11a.50641.50641,0,0,0,.5.5H12v3.87891L15.87891,20H24.5a.50641.50641,0,0,0,.5-.5V13.93054A8.00855,8.00855,0,0,0,26,14Zm6-8a6,6,0,1,1-6-6A6,6,0,0,1,32,6ZM29.14764,3.76642l-.51147-.37879a.29678.29678,0,0,0-.37677.0268l-3.15,2.96057-1.766-.84467a.32278.32278,0,0,0-.377.09528l-.43353.5545a.29677.29677,0,0,0,.02673.37677l2.23328,2.236A.83046.83046,0,0,0,26.09052,8.693L29.2,4.11816A.25359.25359,0,0,0,29.14764,3.76642Z"
				{...this.props}
			/>
		);
	}
}

export default ImActiveIcon;
